<template>
<div class="esrimapcomponent">
	<BetaAlert style="position: fixed; top: 70px; left: 0; right: 0; z-index: 999;" />
	<div ref="map" id="map" class="map">
		<div id="layerList" ></div>
	</div>
	<router-view></router-view>
	<SwitchCampus />
	<!-- <DarkenMapOverlay /> -->
	<Legend v-if="legendOpen" />
	<MOTD />
	<GISServiceDownDialog :serviceDownDialog="serviceDownDialog" v-on:closeDialog="serviceDownDialog = false" />

	<!-- LASSO SELECTION -->
	<div v-if="allowManagerUI || allowOccupantEditorUI"
		style="position: absolute; top:80px; left:20px; width:32px; opacity: 0.8;"  class="thickerOutline">
        <v-card outlined class="my-0" style="border-width: 1px; border-radius: 5px; border-style: solid;">
        	<v-tooltip left>
            	<v-btn slot="activator" class="ma-0" small icon @click="useSelectRectangle()">
            		<v-icon>highlight_alt</v-icon>
            	</v-btn>
            	<span>Lasso Selection Tool</span>
			</v-tooltip>
        </v-card>
    </div>

</div>
</template>

<script>
import { loadModules } from 'esri-loader';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import GlobalElevatorControl from '@/components/GlobalElevatorControl'
import DarkenMapOverlay from '@/components/DarkenMapOverlay'
import SwitchCampus from './SwitchCampus'
import Legend from '@/components/Legend'
import MOTD from '@/components/MOTD'
import GISServiceDownDialog from '@/components/GISServiceDownDialog'
import BetaAlert from '@/components/BetaAlert'
import { LODS } from '../LODs'
import jscookie from 'js-cookie'
import { AUTH_COOKIE } from '../store/modules/user'
import { LINE_DETAIL_COOKIE } from '../store/modules/user'


export default {
	name: 'esri-map',
	mounted: function () {
		loadModules([
		"esri/basemaps", "esri/map", "esri/tasks/query", 
		"esri/geometry/Point",
		"esri/tasks/QueryTask",
		"esri/dijit/Measurement",
		"esri/dijit/Scalebar",
		"esri/SnappingManager",
		"esri/sniff",
		"dojo/keys",
		"esri/units",
		"esri/layers/GraphicsLayer",
		"esri/layers/FeatureLayer",
		"esri/layers/ArcGISTiledMapServiceLayer",
		"esri/layers/ImageParameters",
		"esri/layers/LabelLayer",
		"esri/layers/LayerDrawingOptions",
		"esri/graphic",
		"esri/graphicsUtils",
		"esri/symbols/SimpleLineSymbol",
		"esri/symbols/SimpleFillSymbol",
		"esri/symbols/TextSymbol",
		"esri/symbols/Font",
		"esri/Color",
		"esri/tasks/IdentifyTask",
		"esri/tasks/IdentifyParameters",
		"esri/tasks/FindTask",
		"esri/tasks/FindParameters",
		"esri/tasks/GeometryService",
		'esri/dijit/LayerList',
		"dojo/_base/array", "dojo/query", "dojox/gfx/svg"
	])
	.then(
		([esriBasemaps, Map, Query, Point, QueryTask, Measurement, Scalebar, SnappingManager, has, keys, Units, GraphicsLayer,FeatureLayer,
			ArcGISTiledMapServiceLayer, ImageParameters, LabelLayer, LayerDrawingOptions, Graphic, graphicsUtils,
			SimpleLineSymbol,SimpleFillSymbol, TextSymbol, Font, Color, IdentifyTask,IdentifyParameters,FindTask,FindParameters,
			GeometryService, LayerList, arrayUtils, dojoQuery]) => {

    const PLANZOOMLEVEL = 21

		const BUILDINGHIGHLIGHTLAYER 	= 	'buildinghighlightlayer'
		const BUILDINGFOOTPRINTLAYER    =   'buildingfootprintlayer' 
		const HIGHLIGHTLAYER 			=	'highlightlayer' 	
		const MULTIHIGHLIGHTLAYER 		=	'multihighlightlayer' 
		const HOVERHIGHLIGHTLAYER 		=	'hoverhighlightlayer'
		const ROOMINTERACTIVITYLAYER 	=	'roominteractivitylayer'
		const WHITEOUTLAYER				=	'whiteoutlayer'
		const COLORLAYER				=	'colorlayer'
		const CUSTOMLABELLAYER 			=	'customlabellayer'
		const MASKINGLAYER				=	'masklayer'
		const CADTEXTLAYER				=	'cadtextlayer'



		const buildingSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([0, 0, 0, 1]), 5),
			new Color([255, 0, 0, 0]));

		const footprintSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([0, 0, 255, .1]), 10),
			new Color([255, 0, 0, 0]));

		const darkBuildingSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([100, 0, 0, 1]), 5),
			new Color([255, 0, 0, 0]));

		const transparentSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([0, 0, 0, 0]), 5),
			new Color([255, 0, 0, 0]));

		// Outline Symbol	  		 
  		const outlineSymbol = new SimpleFillSymbol("solid",
		new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([0, 0, 0, 1]), 1),
		new Color([255, 0, 0, 0]));

		const whiteFillSymbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_SOLID,
								    new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
								    new Color([0,0,0]), 1),new Color([255,255,255,1]))

		const blackFillSymbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_SOLID,
								    new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
								    new Color([128,128,128]), 1),new Color([0,0,0,1]))

/*		const maskSymbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_SOLID,
								    new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
								    new Color([0,0,0,0]), 1),new Color([227,223,211,0]))*/

		const highlightSymbol = new SimpleFillSymbol("solid",
			new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([181, 0, 0, .8]), 5),
			new Color([181, 0, 0, .1]));

		const hoverHighlightSymbol = new SimpleFillSymbol("solid",
								new SimpleLineSymbol("solid", new Color([0, 0, 181, .8]), 5),
								new Color([255, 0, 0, 0]));

		const nullHighlightSymbol = new SimpleFillSymbol("solid",
								new SimpleLineSymbol("solid", new Color([255, 0, 0, .8]), 8),
								new Color([255, 0, 0, 0]));

		this.setupSymbols() // Additional symboles in module

		const buildinghighlightLayer = new GraphicsLayer();
		buildinghighlightLayer.id = BUILDINGHIGHLIGHTLAYER;

		const buildingfootprintLayer = new GraphicsLayer();
		buildingfootprintLayer.id = BUILDINGFOOTPRINTLAYER;

		const highlightLayer = new GraphicsLayer();
		highlightLayer.id = HIGHLIGHTLAYER;

		const multihighlightLayer = new GraphicsLayer();
		multihighlightLayer.id = MULTIHIGHLIGHTLAYER;  

		const hoverhighlightLayer = new GraphicsLayer();
		hoverhighlightLayer.id = HOVERHIGHLIGHTLAYER; 

		const roominteractivityLayer = new GraphicsLayer();
		roominteractivityLayer.id = ROOMINTERACTIVITYLAYER;

		const roomnumberlabelsLayer = new GraphicsLayer();
		roomnumberlabelsLayer.id = 'roomnumberlabelslayer';

		const customlabelLayer = new GraphicsLayer();
		customlabelLayer.id = CUSTOMLABELLAYER;

		const buildinglabelLayer = new GraphicsLayer();
		buildinglabelLayer.id = 'buildinglabellayer';

		const whiteoutLayer = new GraphicsLayer();
		whiteoutLayer.id = WHITEOUTLAYER;

		const colorLayer = new GraphicsLayer();
		colorLayer.id = COLORLAYER;

		// BUILDING HOVER HIGHLIGHT 
		const buildinghoverhighlightLayer = new GraphicsLayer()
		buildinghoverhighlightLayer.id = 'buildinghoverhighlightlayer'
		buildinghoverhighlightLayer.title = 'buildinghoverhighlightlayer'

		// PLAN LAYER
		const planLayer = new GraphicsLayer()
		planLayer.id = 'planlayer'
		planLayer.title = 'planlayer'	

		const nullFeatureLayer = new GraphicsLayer();
		nullFeatureLayer.id = 'nullfeaturelayer';

		const cadtextLayer = new GraphicsLayer()
		cadtextLayer.id = CADTEXTLAYER

		const measureGraphics = new GraphicsLayer();
		measureGraphics.id = 'sketchGraphics';

		const geometryService = new GeometryService("https://services.maps.arizona.edu/pdc/rest/services/Utilities/Geometry/GeometryServer");
		this.SET_GEOMETRY_SERVICE(geometryService);     

		let maskingLayer = null

		// I dont know if this is a good hack or not.
		var store = this.$store
		var state = this.$store.state.space
		var route = this.$route

		// I dont know a better way to deal with this
		var vm = this;

		// Watch changes for Hover Room
		/*store.watch(
			function (state) {return state.ui.hoverRoomNumber},
					function (hoverRoomNumber, oldnumber) {
						let payload = {'roomKey': hoverRoomNumber }
						hoverHighlight(payload)
					},
		);*/

		// Get cookie that defaults map center and zoom
		let mapCenterCookie = jscookie.get('mapCenter')
		if (mapCenterCookie) { var mapCenter = JSON.parse(jscookie.get('mapCenter')) }

		// create map with the given options
		const map = new Map(this.$refs.map, {
			center: mapCenter ? mapCenter.center : [-110.95344, 32.231877],
			zoom:  mapCenter ? mapCenter.zoom : 20,
			logo: false,
			lods: LODS,
			smartNavigation: false,
			isZoomSlider: true,
		});

		// Scalebar only on desktop
		if (!vm.$vuetify.breakpoint.xsOnly) { 
			const scalebar = 
				new Scalebar({
			    map: map,
			    attachTo: "bottom-right"
			  });
		}
		
		vm.setMap(map)				// Set Map Var to State	

		//Turn on line detail if the cookie exists and is set to True
		if (this.showLineDetail) { updateLayerVisibility("1") }


		store.watch(
			function (state) {return vm.$store.state.ui.darkTheme},
					function (darkTheme, oldTheme) {
						if (darkTheme) {
							//console.log("Change Background Map Color: " + darkTheme)
							map.removeLayer(basemap)
							map.removeLayer(phxBasemap)
							//map.setBasemap("dark-gray-vector")
							/*map.basemapLayerIds.forEach(id => {
								  map.removeLayer(map.getLayer(id));
								});*/
							map.setBackgroundColor("black")
							//interiorMappingDMSL.setDisableClientCaching(true);

							//interiorServiceURL = vm.darkInterior
							subBasemap.hide()
							maskingLayer.hide()

						} else {
							interiorServiceURL = lightInterior
							//basemapURL = lightBasemap
							map.setBackgroundColor("white")
							//map.setBasemap("topo")
							map.addLayer(basemap)
							map.addLayer(phxBasemap)
							subBasemap.show()
							maskingLayer.show()
						}
						map.removeLayer(interiorMappingDMSL)


					},
		);

		const esriToken				=	jscookie.get(AUTH_COOKIE)

		var basemapURL 				= 	vm.lightBasemapURL
		
		var   lightInterior 
		var	  interiorServiceURL 

		const subBasemap			=	new ArcGISTiledMapServiceLayer(vm.subBasemapURL)	
		const CACBasemap			=	new ArcGISTiledMapServiceLayer(vm.CACBasemapURL)
		const B2Basemap				=	new ArcGISTiledMapServiceLayer(vm.B2BaseMapURL)
		const TPBasemap				=	new ArcGISTiledMapServiceLayer(vm.TPBaseMapURL)
		const phxBasemap			=	new ArcGISTiledMapServiceLayer(vm.phxBasemapURL)
		const UASouthBasemap		=	new ArcGISTiledMapServiceLayer(vm.UASouthBaseMapURL)
		const basemap 				=	new ArcGISTiledMapServiceLayer(basemapURL);


 		//See if we have the Interior service online. If we cannot query for Old Main and get data back, assume service is down.
		store.dispatch('interiorServiceCheck').then((data) => {
			let list = JSON.stringify(data)
			let interiorPresent = list.indexOf("features");
			//Show or hide the GIS services down dialog
			if (interiorPresent > 0) {
				this.serviceDownDialog = false;
			}
			else {
				this.serviceDownDialog = true;
			}

		})

		// Fetch list of layers allowed for this token.  If they can see InteriorRestricted, use that, else Interior.
		store.dispatch('fetchUsersLayerList').then((data) => {
			let list = JSON.stringify(data)
			let n = list.indexOf("InteriorRestricted");

			// Enable / Disable restricted
			if (n>0) { 
				vm.setViewRestricted(true)
				console.log("Using InteriorRestricted") 
			} else {
				vm.setViewRestricted(false)
				console.log("Using Interior (Public)") 
			}
		})

		map.addLayer(subBasemap)	// This really degrades performance
		map.addLayer(basemap)
		map.addLayer(phxBasemap)
		map.addLayer(B2Basemap)
		map.addLayer(CACBasemap)
		map.addLayer(TPBasemap)
		//map.addLayer(UASouthBasemap)		
		
		map.addLayer(buildinghighlightLayer)	
		//map.addLayer(whiteoutLayer)
		map.addLayer(buildinghoverhighlightLayer)
		map.addLayer(buildingfootprintLayer)
		
	
		
		
		
		map.addLayer(roominteractivityLayer);  // Order is important
		map.addLayer(customlabelLayer)
		map.addLayer(multihighlightLayer)
		map.addLayer(colorLayer)
		map.addLayer(planLayer)

		map.addLayer(roomnumberlabelsLayer)		
		map.addLayer(hoverhighlightLayer)
		map.addLayer(highlightLayer)
		
		map.addLayer(nullFeatureLayer)
		map.addLayer(cadtextLayer)
		map.addLayer(buildinglabelLayer)

		map.addLayer(measureGraphics);

		//vm.addGraphicsLayer() // This is a test of modularity

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		    // Useful for testing, making sure layers in correct order
		    // Will display a table of maplayers on left side
		    /*var layerList = new LayerList({
		        map: map,
		        showLegend: true,
		        showSubLayers: false,
		        showOpacitySlider: true,
		        layers: []
		      },"layerList");
		    layerList.startup() */
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		
		// MAP DRAGGED
        map.on("extent-change", (evt) => {
            this.loadRIForExtent()
        })

        // MOUSE WHEEL EVENT
        // This clears label layer, preventing some nasty looking mismatches while zooming.
        //window.addEventListener("wheel", event => { // using this causes labels to clear when scrolling ANYTHING (controls)
        
        map.on("mouse-wheel", (evt) => { // "wheel" was not effective
        	roomnumberlabelsLayer.clear()
        })

		// Watch Zoom, refire updateLayerVisibility
		map.on("zoom-end", function() {
			let zoom = map.getLevel()
			//console.log("Zoom: " + zoom)
			
			if (map.getLevel() < 18) {
				buildinglabelLayer.hide()
				//maskingLayer.hide()
			} else { 
				vm.showBuildingLabels && buildinglabelLayer.show() && maskingLayer.show()
			}
			if (vm.showBuildingLabels) { labelBuildings(zoom) }

			if (vm.clVisible) { adjustFontLabelFontSize(zoom) }
			if (store.state.ui.currentFloor) {
            	updateLayerVisibility(store.state.ui.currentFloor);  // No args will only re-evaluate zoom level
        	}
    	})

    	map.on("key-up", function(evt) {
			if (evt.key == 'z') {
				map.setZoom(19)
			}
    	})

    	var mouseX
		var mouseY
		var deltaX
		var deltaY


        map.on("mouse-down", function(evt) {
            mouseX = evt.x
            mouseY = evt.y
        });



        // BUILDING CLICK
        buildingfootprintLayer.on("mouse-up", (evt) => { 
        	console.log("Building Footprint Layer mouse-up Event")
            if (evt.graphic) { 
				if (vm.roomAssociationSidebarOpen) {
					vm.fetchBuildingFiles(evt.graphic.attributes["Buildings.SpaceNumLetter"])
					.then((data) => {
						if (data.length>0) {
							const payload = data.find((floor) => floor.floor == vm.currentFloor ).CADName
			  				console.log(payload)
			  				vm.addNullFeatures({'floor': vm.currentFloor, 'docName': payload })
		  				}	
				})
				} else {
					vm.updateSelectionCentering(false)
					switchBuildings(evt.graphic.attributes['Buildings.SpaceNumLetter']) 
				}
			} 
            
        })

        buildinghoverhighlightLayer.on("mouse-up", (evt) => { 
        	console.log("Building Footprint Hover Layer mouse-up Event")
            if (evt.graphic) { 
				if (vm.roomAssociationSidebarOpen) {
					vm.fetchBuildingFiles(evt.graphic.attributes["Buildings.SpaceNumLetter"])
					.then((data) => {
						if (data.length>0) {
							const payload = data.find((floor) => floor.floor == vm.currentFloor ).CADName
			  				console.log(payload)
			  				vm.addNullFeatures({'floor': vm.currentFloor, 'docName': payload })
		  				}	
				})
				} else {
					vm.updateSelectionCentering(false)
					switchBuildings(evt.graphic.attributes['Buildings.SpaceNumLetter']) 
				}
			} 
            
        })

    	// ROOM CLICK EVENTS
        hoverhighlightLayer.on("mouse-up", (evt) => { evt.graphic &&
        	//console.log("Room Click Event from hoverhighlightlayer")
             !isMapDrag(evt) && this.roomClickEvent(evt)
        })
        highlightLayer.on("mouse-up", (evt) => { evt.graphic &&
        	//console.log("Room Click Event from highlightlayer")
             !isMapDrag(evt) && this.roomClickEvent(evt)
        })
        colorLayer.on("mouse-up", (evt) => { evt.graphic &&
        	//console.log("Room Click Event from highlightlayer")
             !isMapDrag(evt) && this.roomClickEvent(evt)
        })
        multihighlightLayer.on("mouse-up", (evt) => { evt.graphic &&
        	//console.log("Room Click Event from multihighlightLayer")
             !isMapDrag(evt) && this.roomClickEvent(evt)
        })
	    
	    // ROOM HOVER EVENTS
        roominteractivityLayer.on("mouse-over", (evt) => { evt.graphic && 
            this.roomHoverEvent(evt.graphic)
        })  
        colorLayer.on("mouse-over", (evt) => { evt.graphic && 
            this.roomHoverEvent(evt.graphic)
        }) 
        multihighlightLayer.on("mouse-over", (evt) => { evt.graphic && 
        	console.log("Room Hover over multihighlightLayer Layer")
            this.roomHoverEvent(evt.graphic)
        }) 
        roomnumberlabelsLayer.on("mouse-over", (evt) => { evt.graphic && 
        	console.log("Room Hover over multihighlightLayer Layer")
          this.roomHoverEvent(evt.graphic.roomGraphic)
        }) 

        // BUILDING HOVER
        buildingfootprintLayer.on("mouse-over", (evt) => { evt.graphic &&        	
            this.buildingHoverEvent(evt.graphic)
        })




	    // Calculate Mouse Movement
	    function isMapDrag(event) {
	        // Determine Mouse Delta before deciding to pass on click
	        // greater than 12 pixels of movement will not be a click
	        // This makes clicking a lot more user friendly
	        deltaX =  Math.abs(mouseX - event.x) 
	        deltaY =  Math.abs(mouseY - event.y) 
	        let mouseDelta = deltaX + deltaY
	        //console.log("mouseDelta", mouseDelta)       
	        if (mouseDelta > 12) { return true }
	    }

		// A map click on a blank spot (non-graphic) will clear the map.
        /*map.on("click", function(evt) {
        	if (!vm.roomAssociationSidebarOpen) { // Do not clear if using Room Association
				if (!evt.graphic) {
					vm.selectBuilding(null)		// Asynchronous Action
					vm.setSelectedRoom(null)
					vm.updateBulkRoomEditSideBar(false)
					vm.setMultiSelectRoomArray([])
					clearGraphics();
				}
			}
        })*/

    	// A map click on a blank spot (non-graphic) will clear the map.
    	map.on("click", function(evt) {
    		// Identify
			evt.graphic && evt.graphic.attributes && identifyRoom(evt.graphic)
			if( !evt.graphic && !vm.roomAssociationSidebarOpen ) {	// Do not clear if using Room Association		

				// Reset the map
				//console.log("Click not on a graphic.")				
				vm.selectBuilding(null)		// Asynchronous Action
				vm.setSelectedRoom(null)
				vm.updateBulkRoomEditSideBar(false)
				vm.setMultiSelectRoomArray([])
				clearGraphics() // This was commented out?  Didn't know why
			}
		})


		let nullClickHandle = nullFeatureLayer.on("mouse-up", function(evt) {

			//Do not process null feature click if not a superuser
			if (vm.$store.state.user.isSuperUser) {
				let prefix = "R_Level_" + vm.currentFloor + "." 
				let room = evt.graphic.attributes	
				room.Join_Key = room[prefix + 'Join_Key'] || room["Join_Key"]			
				room.ehandle = room[prefix + 'Handle'] || room['Handle']
				room.dwgName = room[prefix + 'DocName'] || room['DocName']

				// Used to associate JoinKey and Area to database
				vm.setAssociationRoom(room)
				vm.updateRoomAssociationSidebar(true)

				if (vm.autoMode && !evt.ctrlKey) { 
					vm.setAssociationRoom(room).then(() => { vm.newRoomAutoSave()})
				}

				let multiSelect = evt.ctrlKey ? true : false 
				vm.highlightNullFeature({ 'joinKey' : room.Join_Key, 'multiSelect' : multiSelect })
				
				if (multiSelect) {
					//console.log("Multi-select from initialInterior")
					vm.updateBulkRoomEditSideBar(true)
					// If there is already a single-selected room, add this to the array first. or maybe not, commentd out
					//vm.databaseRoom && vm.addToMultiSelectRoomArray(vm.databaseRoom)
					// If this is the first multi-select, clear previous highlighted rooms.
					vm.multiSelectRoomArray.length==0 && clearGraphics('highlightlayer') 
					// Then add one that was clicked
					vm.fetchFullRoomByJoinKey({ 'joinKey': room.Join_Key }).then((data) => {
						console.log(data)
						if (typeof data == 'object') { vm.addToMultiSelectRoomArray(data) }

					})
				}	
			}		
		});
		//console.log("Null Click Event Handle", nullClickHandle)
		

		nullFeatureLayer.on("mouse-over", function(evt) {
			//console.log("Moused Over Null Feature")
			if (evt.graphic && evt.graphic.attributes ) {
				let keyName = "R_Level_" + vm.currentFloor + ".Join_Key"
				let keyNameInitial = "Join_Key"
				let joinKey = evt.graphic.attributes[keyNameInitial] || evt.graphic.attributes[keyName]
				let payload = {'joinKey' : joinKey}
				vm.hoverHighlightNullFeature( payload )				
			}
		});

		nullFeatureLayer.on("mouse-out", function(evt) {
			clearGraphics(HOVERHIGHLIGHTLAYER);
			vm.setHoverRoomNumber(null)
		});


    	// 12/2/21 Previous mouse functions before merge of 'performance' branch.  Saved for reference / future bugs
    	//
		/*var mouseX
		var mouseY
		var deltaX
		var deltaY

		map.on("mouse-down", function(evt) {
			mouseX = evt.x
			mouseY = evt.y
		});

		// Map Click Events (Room Clicking and Bldg Clicking)
		// Use of "click" means any movement between up and down invalidates the click
		// Use of mouse-down interfered with centering on a clicked room selection.
		// Uses mouse-up instead.
		map.on("mouse-up", function(evt) {
			// Determine Mouse Delta before deciding to pass on click
			deltaX =  Math.abs(mouseX - evt.x) 
			deltaY =  Math.abs(mouseY - evt.y) 
			let mouseDelta = deltaX + deltaY
			
			// alt panning will never result in a selection
			// greater than 4 pixels of movement will not select either
			if (evt.altKey || mouseDelta > 4) { 
				//console.log("Alt Key or clickDrag detected.  Do not open Room Detail")
				return }

			if (store.state.ui.measureOpen || vm.roomAssociationSidebarOpen || vm.roomCollectionAutoAdd) { return }
			// Pause resume map click actions
			
				
				if (evt.graphic && evt.graphic.attributes["ROOMEXT.RM_ID"]) {
					let roomKey = evt.graphic.attributes["ROOMEXT.roomKey"]
					let roomNumber = evt.graphic.attributes["ROOMEXT.RM_ID"]
					let bldgAlpha = evt.graphic.attributes["ROOMEXT.BldgAlpha"]
					if (state.selectedRoom && state.selectedRoom.roomKey == roomKey) {
						console.log("Clicked Same Room")
						let delArray = []
						delArray.push(roomKey)
						removeGraphic(delArray, 'single') // 
						vm.setSelectedRoom(null)
					} else {						
						let multiSelect = evt.ctrlKey ? true : false 

						// Single Clicks
						if (!multiSelect) {
							// drennen 9/10/20 line below commented out because fetchfullroom also sets room.
							// This was originally to create more responsive interface (using shallow data first), but not sure its needed
							// Has some undesired effects.
							//vm.setSelectedRoom(vm.getRoom(roomKey)) // pre-fetched data for speed
							vm.fetchFullRoom({bldgAlpha: bldgAlpha, number: roomNumber}) // Needed for child tables
							vm.updateBulkRoomEditSideBar(false)
						// Multi Clicks
						} else {
							// If there is already a single-selected room, add this to the array first.
							// Nevermind that
							// vm.selectedRoom && vm.addToMultiSelectRoomArray(vm.selectedRoom)

							// Clear single-selections if the bulkedit sidebar has not opened yet
							if (!vm.BulkRoomEditSideBarOpen) { clearGraphics(HIGHLIGHTLAYER) }

							// THIS WILL CLOSE contentsidebar updatecontentsidebar(false)						
							vm.updateBulkRoomEditSideBar(true)

							vm.setSelectedRoom(null)
							//console.log("Roomkey: "+ roomKey)
							
							// Now add the one that was ctrl-clicked.
							// Attempt to get data locally first
							let room = vm.getRoom(roomKey)
							if (typeof room == 'undefined') {
							//if (room === 'undefined') {
								vm.fetchFullRoom({bldgAlpha: bldgAlpha, number: roomNumber}).then((data) => {
									vm.addToMultiSelectRoomArray(data)
								})
							} else {
								vm.addToMultiSelectRoomArray(room)
							}
						}
						highlightRoom({'roomKey' : roomKey, 'multiSelect' : multiSelect})
					}
				}		
		});*/



		map.on("load", function() {

			//console.log("Map Loaded")

			// Set Phone Zoom
			vm.$vuetify.breakpoint.xsOnly && map.setZoom('18') 
			
			vm.addExtents()
			addBuildingFootprints()

			// Watch buildingRooms and floor changes to execute colorRooms
			store.watch(
				() => { return vm.buildingRooms + vm.currentFloor },
					function (newVal, oldVal) {
						vm.buildColorizedLegendArray()
					}
			);

			store.watch(
				() => { return vm.clVisible},
					function (newval) {
				    	if (newval) {
				    		// Suppress normal roomnumberlabellayer  
				    		roomnumberlabelsLayer.hide()				    		
				    	} else {
				    		// Restore normal roomnumberlabellayer  
				    		roomnumberlabelsLayer.show()
			    	}
			    },
	  		);

/*			store.watch(		// This is only being saved because it was difficult to figure this out.  Suppress Labels
				() => { return vm.clVisible},
					function (newval) {
				    	if (newval) {
				    		// Suppress labels from DSML.  
							var optionsArray = [];  
							var drawingOptions = new esri.layers.LayerDrawingOptions();  
							drawingOptions.showLabels = false; 
							for (var i = 14; i <= 27; i++) { // apply to layers 16-27
							  optionsArray[i] = drawingOptions
							} 
							vm.interiorMappingDMSL.setLayerDrawingOptions(optionsArray); 

				    	} else {
				    		// Restore labels from DSML.  
							var optionsArray = [];  
							vm.interiorMappingDMSL.setLayerDrawingOptions(optionsArray); 
			    	}
			    },
	  		);*/

			// Watch of Bldg / Floor / Room
			// Want to use this for more coordinated (non-duplicating) map functions
			// This watch was created prior to understanding how to access the map from a state action.
			// Using state actions would be better than this.
			store.watch(
				 () => { return store.getters.getMapSelectors },
					function (newVal, oldVal) {
						//console.log("Watch: mapSelections Changed ")
						let [oldBldg, oldFloor, oldRoom] = oldVal.split('|');
	      				let [newBldg, newFloor, newRoom] = newVal.split('|');
	      				//console.log("Bldg/Floor/Room: ", `${oldBldg} => ${newBldg} | ${oldFloor} => ${newFloor} | ${oldRoom} => ${newRoom}`)
	      				//console.trace("trace")
	      				oldBldg = (oldBldg != 'null') ? oldBldg : null
	      				oldFloor = (oldFloor != 'null') ? oldFloor : null
	      				oldRoom = (oldRoom != 'null') ? oldRoom : null
	      				newBldg = (newBldg != 'null') ? newBldg : null
	      				newFloor = (newFloor != 'null') ? newFloor : null
	      				newRoom = (newRoom != 'null') ? newRoom : null

	      				if (newBldg != oldBldg) {
							if (store.state.ui.singleBuildingMode) { setSingleBuilding() }								
							highlightBuilding()
						} 

						if (newFloor != oldFloor ) {
							clearGraphics()		
							vm.loadRIForExtent()
							vm.selectedBuilding && vm.addFloorPlanDetail(vm.selectedBuilding.bldgAlpha)
						}

						if (newFloor != oldFloor || newBldg != oldBldg) {
							addRoomInteractivity() 								
							updateLayerVisibility(newFloor)							
						}

	      				if (newRoom && (newRoom != oldRoom)) {
							highlightRoom( {'roomKey' : newRoom } )

							// This would completely disable sidebar for phone
							//if (!vm.$vuetify.breakpoint.xsOnly) {
    							vm.updateContentSidebar(true);
    						//}
						}

						if (!newRoom) {
							vm.updateContentSidebar(false)
						}

						if (!newBldg) {
							clearGraphics(BUILDINGHIGHLIGHTLAYER)
						}
					}
			);

			if (route.params.link) {
				vm.updateCollectionSidebar(true)
			}

			// Routing will turn on centering.  Building and Room Highlight functions turn it off.
			
	        	if (route.params.room) {
	        		//console.log("Route to Building+Room Highlight")
	        		
	        		if (state.buildings.length>0) {
	        			vm.selectBuilding(route.params.bldg).then(() => { 
	        				vm.updateSelectionCentering(true)
	        				vm.fetchFullRoom({bldgAlpha: route.params.bldg, number: route.params.room})
	        			})
	        		} else {
	        			vm.fetchBuildings().then(() =>  {
						vm.updateSelectionCentering(true)
						vm.selectBuilding(route.params.bldg).then(() => vm.fetchFullRoom({bldgAlpha: route.params.bldg, number: route.params.room}))
					})
				}

			} else if (route.params.bldg) {
				//console.log("Route to Building Highlight")
				vm.updateSelectionCentering(true)
				if (state.buildings.length > 0) { vm.selectBuilding(route.params.bldg) }
				else {					    vm.fetchBuildings().then(() => vm.selectBuilding(route.params.bldg)) }
			}

			store.watch(function (state) {return state.ui.showBuildingLabels},
						function (visible) {
							let maskingLayer = map.getLayer('maskinglayer')
							if (visible)	{ 
								buildinglabelLayer.show()
								!vm.darkTheme && maskingLayer.show()
							} else { 
								buildinglabelLayer.hide()
								maskingLayer.hide()
							}
						}
			); 

			// These two necessary for setting initial map center

			/*	store.watch(function (state) {return state.mapFunctions.mapReady + state.user.userProfile },
					function () {
						if (vm.userProfile && vm.mapReady)	{ 
							if (vm.userProfile.mapCenterX) {
								map.centerAt(new Point(vm.userProfile.mapCenterX, vm.userProfile.mapCenterY))
								vm.userProfile.mapZoom && map.setZoom(vm.userProfile.mapZoom)									
							}
						}
					}
				);*/



			store.watch(function (state) {return state.ui.singleBuildingMode},
						function (mode) {
							if (mode)	{ 
								setSingleBuilding() 
							} else { 
								setSingleBuilding("clear") 
							}
						}
			); 

			store.watch(function (state) {return state.ui.showLineDetail},
						function (newVal) {
							updateLayerVisibility(vm.currentFloor)						
						}
			); 

			store.watch(
				 () => { return store.getters.getLabelState },
					function (newVal, oldVal) {
						applyLabels()
					}
			);

			store.watch(function (state) {return state.ui.showBasemap},
						function (show) {
							if (show)	{ 
								basemap.show() 
								phxBasemap.show()
								//subBasemap.show()
							} else { 
								basemap.hide() 
								phxBasemap.hide()
								//subBasemap.hide()
							}
						}
			); 

			vm.setMapReady(true)			
		}) // End of Load Event

		
			

		// Hover-over effect for room polygons on the buildingfootprintLayer layer
		/*buildingfootprintLayer.on("mouse-over", function(evt) {

			// dont use room interactivity when in RA Mode
			//if (vm.roomAssociationSidebarOpen){ return }

			let gBldg = evt.graphic.attributes["Buildings.SpaceNumLetter"]			
			hoverHighlightBuilding(gBldg)
			addRoomInteractivity(gBldg)
			
		});*/


		////////////////////////////////////////////////////////////////////////////////////
		//
		// FUNCTIONS
		//
		//
		
		function switchBuildings(bldgAlpha) {
			//console.log("switchBuildings");
			if (!state.selectedBuilding || state.selectedBuilding.bldgAlpha != bldgAlpha) {
				//console.log("Select Building: ", bldgAlpha)
				vm.selectBuilding(bldgAlpha)   			// Asynchronous Action
			}
		}

		// This could be developed to have results in the dom template.  An option could turn it on/off.
		function identifyRoom(graphic) {	
			// Show the roomKey in console
			let roomKey = graphic.attributes["ROOMEXT.roomKey"]
			let prefix = "R_Level_" + store.state.ui.currentFloor + "."
			let joinKey = graphic.attributes[prefix + 'Join_Key']

			roomKey && console.log("Identify: roomKey", roomKey, joinKey)
			!roomKey && console.log("Identify: Graphic", graphic)

			// duplicated in null feature highlight
			// If theres no roomKey, this is an unassociated room.  Show the Join Key instead
			//let prefix = "R_Level_" + store.state.ui.currentFloor + "."
			//!roomKey && console.log("Identify: Join_Key", graphic.attributes[prefix + 'Join_Key'])
		}

		// This function was never restored after switch from DMSL
		function setSingleBuilding(clear) {

		}

		function hoverHighlightBuilding(bldg) {
	    	const symbol = footprintSymbol;
	        clearGraphics(HOVERHIGHLIGHTLAYER)

	        if (bldg) {
		    	const fGraphic = 
		    	   buildingfootprintLayer.graphics.find(graphic => {return graphic.attributes["Buildings.SpaceNumLetter"] === bldg});

		    	if (fGraphic) {    
		    		// Copy the graphic, otherwise its a pointer	
		    		const hGraphic = new Graphic(fGraphic.toJson())
		    		hGraphic.setSymbol(symbol)
		    		//console.log("set Building HoverGraphic")
					hoverhighlightLayer.add(hGraphic)
				}	   
			} 	
	    }


		const highlightBuilding = async () => {
			var bldg = (state.selectedBuilding) ? state.selectedBuilding.bldgAlpha : null
			clearGraphics(BUILDINGHIGHLIGHTLAYER)
			if (bldg) {
				const fGraphic = 
		    	   buildingfootprintLayer.graphics.find(graphic => {return graphic.attributes["Buildings.SpaceNumLetter"] === bldg});

		    	if (fGraphic) {    
		    		// Copy the graphic, otherwise its a pointer	
		    		const hGraphic = new Graphic(fGraphic.toJson())
		    		//console.log("set Building Highlight Graphic")
		    		hGraphic.setSymbol(vm.$store.state.ui.darkTheme ? darkBuildingSymbol : buildingSymbol);
					buildinghighlightLayer.add(hGraphic)

					if (vm.selectionCentering ) {
						await map.setExtent(esri.graphicsExtent([hGraphic]).expand(1.25));
						vm.updateSelectionCentering(false)  // This is here to reset the default state of false.  It has to be explictly flipped to true, numerous places.
					} else { /* console.log("Centering Off") */}
				} else { 
					// Fetch instead.  Needed for direct-to-building url routing.
					//console.log("Building Not Found in Local Graphics.  Trying Fetch")					
					var queryTask = new QueryTask(vm.buildingFootprintURL);
					var query = new Query();
									query.returnGeometry = true;
									query.outFields = ["*"];
									query.where = "Buildings.SpaceNumLetter = '" + bldg + "'";

					queryTask.on("complete", function(event) {
						var features = event.featureSet.features;
						if (features.length > 0) {
							features.forEach((graphic) => {
								graphic.setSymbol(vm.$store.state.ui.darkTheme ? darkBuildingSymbol : buildingSymbol);
								buildinghighlightLayer.add(graphic);

									if (vm.selectionCentering ) {
										map.setExtent(esri.graphicsExtent(features).expand(1.25));
										vm.updateSelectionCentering(false) // This is here to reset the default state of false.  It has to be explictly flipped to true, numerous places.
									}
							})
						} 
					});

					queryTask.execute(query);
				}

			} // else { console.log("Asked to highlight building, but no building selected")}
		}

		vm.setHighlightBuildingFunction(highlightBuilding)

	    // Will find matching roominteractivity graphic, copy it and add it to hoverhighlightlayer.
	    // Tremendously faster than a fetch/query to rest service.
	    function hoverHighlight(payload) {
	    	let symbol = hoverHighlightSymbol;
	        clearGraphics(HOVERHIGHLIGHTLAYER)
			let fGraphic = roominteractivityLayer.graphics.find(graphic => {return graphic.attributes["ROOMEXT.roomKey"] === payload.roomKey});

		    	if (fGraphic) {    
		    		const hGraphic = new Graphic(fGraphic.toJson()) // Copy object
		    		hGraphic.setSymbol(symbol)
					hoverhighlightLayer.add(hGraphic)
				}
	    }

		const highlightRoom = (payload) => {	// payload is a room object
			let roomKey = payload.roomKey
			let multiSelect = payload.multiSelect
			//console.log("Centering: ", vm.selectionCentering)
			var symbol = highlightSymbol;

			// Detect Duplicate in highlight layer
/*			const dupGraphic = highlightLayer.graphics.find(graphic => { return graphic.attributes["ROOMEXT.roomKey"] === roomKey });
			if (dupGraphic) { console.log("Already Highlighted", dupGraphic); return; }*/

			const fGraphic = roominteractivityLayer.graphics.find(graphic => { return graphic.attributes["ROOMEXT.roomKey"] === roomKey });

			// attempt to find a match in the room interactivity layer.  If none is found, do a fetch.
			if (fGraphic) {    
		    		// Copy the graphic, otherwise its a pointer	
		    		const hGraphic = new Graphic(fGraphic.toJson())
		    		hGraphic.setSymbol(symbol)
		    		if (!multiSelect) { 
		    			clearGraphics(HIGHLIGHTLAYER) 
		    		}
		    		//console.log("Highlighting from featureLayer - No Fetch")
					highlightLayer.add(hGraphic)
					var pt = hGraphic.geometry.getExtent().getCenter();
					//console.log("Width", hGraphic.geometry.getExtent().getWidth(), "Height", hGraphic.geometry.getExtent().getHeight() )
					if (vm.selectionCentering ) {
						map.centerAt(pt)
						vm.updateSelectionCentering(false) // This is here to reset the default state of false.  It has to be explictly flipped to true, numerous places.
					}
			} else {
				console.log("Not found in roominteractivity, perform fetch.")
				var serviceURL = vm.viewRestricted ? vm.secureFloorURL[state.selectedRoom.floor] + '?token='+esriToken : vm.floorURL[state.selectedRoom.floor]

				var queryTask = new QueryTask(serviceURL);
			        var query = new Query();
			        query.returnGeometry = true;
			        query.outFields = ["*"];
			        query.where = "ROOMEXT.roomKey = '" + roomKey + "'"; 

		        queryTask.on("complete", function (event) {
		        	clearGraphics(HIGHLIGHTLAYER);
		            var features = event.featureSet.features;
		            if (features.length > 0) {   
		                features.forEach((graphic) => {
		                    // Symbolize the fetched graphic, add it to the GraphicsLayer, and add that to the map.
		                    graphic.setSymbol(symbol);	
		                    console.log("Adding Fetched Highlight Graphic")
		                    highlightLayer.add(graphic);
								var pt = graphic.geometry.getExtent().getCenter();
								if (vm.selectionCentering) {
									map.centerAt(pt); 
									vm.updateSelectionCentering(false) // This is here to reset the default state of false.  It has to be explictly flipped to true, numerous places.
								}
		                })
		            } else { 
		            	console.log("Highlight Room: No Features " + serviceURL + ":" + query.where); };
		        });

		        queryTask.execute(query);

		        // If selected room is on a different floor, switch to that floor.
				if ( 	state.selectedRoom && state.selectedRoom.floor != store.state.ui.currentFloor) {
						vm.setCurrentFloor(state.selectedRoom.floor)
				}
			}
		}
		vm.setHighlightRoomFunction(highlightRoom)

		const removeGraphic = (roomKeys, single) => {
			console.log("Remove Graphics: ", roomKeys)
			roomKeys.forEach((key) => {
				if (!single) {
					multihighlightLayer.graphics.forEach((graphic) => {
						if (graphic.attributes["ROOMEXT.roomKey"] == key ) {
							multihighlightLayer.remove(graphic)
						}
					})
				}
				highlightLayer.graphics.forEach((graphic) => {
					if (graphic.attributes["ROOMEXT.roomKey"] == key ) {
						highlightLayer.remove(graphic)
					}
				})
			})
		}

		vm.setRemoveGraphicFunction(removeGraphic)

		// Highlights Rooms by Key
		const highlightRoomsByKey = (roomKeys, color, centerAndZoom, siteID) => {	
			console.log("SiteID: ", siteID)	
			let where = ""

			if(!color) {
				var symbol = highlightSymbol;
			} else {
				var symbol = new SimpleFillSymbol("solid",
				new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, Color.fromRgb(color), 3), Color.fromRgb(color));
			}

			const serviceURL = vm.viewRestricted ? vm.secureFloorURL[store.state.ui.currentFloor] + '?token='+esriToken : vm.floorURL[store.state.ui.currentFloor]			
			let deptID = null
			if (roomKeys.constructor === Array) {
				const arraystring = roomKeys.map((key) => {
					return "'" + key + "'"
				})
				where = "ROOMEXT.roomKey in (" + arraystring + ")";			

			} else { // Assume roomKey is instead a dept ID (function overloading)
				deptID = roomKeys
				where = "ROOMEXT.DeptID = '" + deptID + "'"

			}
			//console.log("HighlightRoomsByKey arraystring: " + arraystring)
			//console.log("ServiceURL: " + serviceURL)	        

	        var queryTask = new QueryTask(serviceURL);
						        var query = new Query();
						        query.returnGeometry = true;
						        query.outFields = ["*"];
						        query.where = where; 
						        if (siteID) { 	console.log("Adding Limiting Extent to query", vm.siteExtents[siteID]); 
						        				query.geometry = vm.siteExtents[siteID]; }
						        //console.log(query.where)

	        queryTask.on("complete", function (event) {

        		//Clear any current matching features
				//console.log(multihighlightLayer.graphics.length)
				if (roomKeys.constructor === Array) {
					roomKeys.forEach((key) => {
						multihighlightLayer.graphics.forEach((graphic) => {
							//console.log(key)
							if (graphic.attributes["ROOMEXT.roomKey"] == key ) {
								multihighlightLayer.remove(graphic)
							}
						})
					})
				} else {
					multihighlightLayer.graphics.forEach((graphic) => {
						if (graphic.attributes["ROOMEXT.DeptID"] == deptID ) {
							console.log("Removing Graphic")
							multihighlightLayer.remove(graphic)
						}
					})
				}



				multihighlightLayer.graphics.forEach((graphic) => {
					roomKeys.forEach((key) => {
						if (graphic.attributes["ROOMEXT.rm_key"] == key ) {
							multihighlightLayer.remove(graphic)
						}
					})
				})

				//console.log(multihighlightLayer.graphics.length)

	            // Populate a Category Legend for highlighted rooms
	            // Thought about improving and generalizing this, but I dont' like how this is driven off of graphics instead of database.  
	            var features = event.featureSet.features;
	            if (features.length > 0) {   
	            	let filteredArray = []
	                features.forEach((graphic) => {
	                    // Symbolize the fetched graphic, add it to the GraphicsLayer, and add that to the map.
	                    if (color == 'category') {
	                    	let category = vm.categoryColors.find((category) => category.name == graphic.attributes['ROOMEXT.RoomCategory'])
	                    	if (category) {
		                    	if (filteredArray.findIndex((item) => item.name == category.name) == -1) {
		                    		filteredArray.push({name: category.name, color: category.color})
		                    	}
		                    	let newcolor = category.color
		                    	newcolor = "rgba("+newcolor[0]+","+newcolor[1]+","+newcolor[2]+","+"0.7)";
		                    	symbol = new SimpleFillSymbol("solid",
										 new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([80, 80, 80, 1]), 3), Color.fromRgb(newcolor));
		                	}
	                    } 
	                    graphic.setSymbol(symbol);	   
	                    //console.log("Adding Graphic")                 
	                    multihighlightLayer.add(graphic);
	                })
	                vm.setLegendColors(filteredArray)
	            	//Having hard time picking right zoom.  Maybe it should zoom to the containing building.
					if (centerAndZoom) {
						map.setExtent(esri.graphicsExtent(features).expand(3))
					}
					

	            } else { 
	            	console.log("Highlight Room: No Features ")// + serviceURL + ":" + query.where)
	            	return "No Features on Current Floor: "// + store.state.ui.currentFloor)
	            }
	            	
	        });

	        //console.log(query.where)

	        queryTask.execute(query);
		}

		vm.setHighlightRoomsByKeyFunction(highlightRoomsByKey)


// Moved to colorRooms.js
/*		function colorRooms() {			
			
			// colorize Array is built reactively when a new colorizeProperty is chosen through UI
			// and when floor or building is changed
			// It contains the legend label, color, and summarized area before colorRooms is called.
			const colorizeArray = store.getters.colorizeArray
			
			console.log("Color Rooms")
			const layer = colorLayer
			const serviceURL = vm.viewRestricted ? vm.secureFloorURL[store.state.ui.currentFloor] + '?token='+esriToken : vm.floorURL[store.state.ui.currentFloor]

	        // Fetch all room features for current building.  
	        const queryTask = new QueryTask(serviceURL)
						        var query = new Query()
						        query.returnGeometry = true
						        query.outFields = ["*"]
						        query.where = "ROOMEXT.BldgAlpha = '" + state.selectedBuilding.bldgAlpha + "'" 

	        queryTask.on("complete", function (event) {
	        	clearGraphics(COLORLAYER)	
	            const features = event.featureSet.features;

	            if (features.length > 0) {   
	            	const featureAttribute = store.state.space.colorizeFeatureAttribute
	            	if (!featureAttribute) { return }

	                // Loop through every feature.  Should this be limited to current floor?
	                features.forEach((graphic) => {

	                	// create copy (not a pointer) of graphic
						const hGraphic = new Graphic(graphic.toJson())	

						// Get value of room attribute (type, use, etc).  Value = (office, restroom, etc)		
						let attributeValue = graphic.attributes[featureAttribute]

						// Use value to lookup corresponding legend item in colorizeArray and get its color.  
						const colorizeInfo = colorizeArray.find((row) => {return row.categoryVal === attributeValue })

						if (colorizeInfo) {
							// If using custom labels, first put down solid white underneath color graphic
							if (vm.clVisible) {
								const wGraphic = new Graphic(hGraphic.toJson())
								wGraphic.setSymbol(whiteFillSymbol)
								layer.add(wGraphic)
							}

							// Get the color to be used
							const colorVal = getColor(colorizeInfo.color)
							
							// Create symbol using color
							let symbol = new SimpleFillSymbol("solid",  new SimpleLineSymbol("solid", new Color(colorVal), 2),new Color(colorVal))
							
							// Instead of white, just use transparent
							if (colorizeInfo.color == 'rgb(255, 255, 255)') {
								symbol = transparentSymbol
							}

		 	    			// Add graphic to color layer.
		 	    			hGraphic.setSymbol(symbol)
							layer.add(hGraphic)
						}
	                })
	                console.log(layer.graphics.length + " Colored Rooms in Layer")
	            } else { 
	            	console.log("Highlight Room: No Features " + serviceURL + ":" + query.where); };
	        });

	        queryTask.execute(query);
	
		}*/


/*		function colorRooms() {			// This version of the function used roominteractivity graphics for speed.  Async issues however.	
			console.log("Color Rooms")
			clearGraphics(COLORLAYER)

			if(store.state.space.colorizeProperty) {
				//console.log("Color Category: " + store.state.space.colorizeProperty)
				const layer = colorLayer
				console.log("About to Color " + roominteractivityLayer.graphics.length + " rooms")
				if (roominteractivityLayer.graphics.length > 0) {

					const colorizeArray = store.getters.colorizeArray

					roominteractivityLayer.graphics.forEach((graphic) => {
						//console.log("Graphic Evaluation")
						const hGraphic = new Graphic(graphic.toJson())						
						const featureAttribute = store.state.space.colorizeFeatureAttribute
						const attributeValue = graphic.attributes[featureAttribute]
						//console.log("Match this: " + attributeValue)
						//console.log("With one of these: ")
						//colorizeArray.forEach((row) => { console.log(row.categoryVal)})

						const colorizeInfo = colorizeArray.find((row) => {return row.categoryVal === attributeValue })

						//console.log(colorizeInfo)
						const colorVal = getColor(colorizeInfo.color)
						const symbol = new SimpleFillSymbol("solid",  new SimpleLineSymbol("solid", new Color(colorVal), 2),new Color(colorVal))

		 	    		hGraphic.setSymbol(symbol)
						layer.add(hGraphic)
						console.log(roominteractivityLayer.graphics.length + " rooms colored")	
					})	
				} else { console.log("No RoomInteractivity Graphics")}
			}			
		}
*/
		function getColor(color) {
			const colorValue = color.replace(/[rgb()\s]/g, '')
            const colorVal = colorValue.split(",")
            colorVal.push(0.45)	//  Transparency
			return colorVal
		}

	    // No argument means clear everything.
		const clearGraphics = (layerid) => {
			// Put back some graphics
			const fpLayer = new GraphicsLayer()
			buildingfootprintLayer.graphics.map((graphic) => { fpLayer.add(graphic) })
			const graphicLayerIds = map.graphicsLayerIds;
			//console.log("Asked to Clear " + layerid);
			map.graphicsLayerIds.forEach((graphicsLayerId) => {
			  const gLayer = map.getLayer(graphicsLayerId);

			  if (layerid) {
					if (gLayer.id == layerid) {
						//console.log("Match Found, Clearing Specified " + gLayer.id);
						gLayer.clear();
					}
				} else { 
					//console.log("Clearing in aggregate " + gLayer.id);

					// Skip Certain Layers
					if (gLayer.id == 'buildinglabellayer') { return }
					if (gLayer.id == 'buildinghighlightlayer') { return }
					if (gLayer.id == 'roomnumberlabelslayer') { return }
					if (gLayer.id == 'roominteractivitylayer') { return }
					//if (gLayer.id == 'nullfeaturelayer') { return } // DB 2/2/2023 commented this out, because nullfeatures stack up as you switch floors.

					gLayer.clear(); 
					map.graphics.clear(); 
					fpLayer.graphics.map((graphic) => { buildingfootprintLayer.add(graphic) } )
				}
			});
		}

		// experimental function that has list of exceptions
/*		const clearGraphics = (layerid, exceptions) => {
			const fpLayer = new GraphicsLayer()
			buildingfootprintLayer.graphics.map((graphic) => { fpLayer.add(graphic) })

			let cgThis = this
			const graphicLayerIds = map.graphicsLayerIds;
			//console.log("Asked to Clear " + layerid);
			map.graphicsLayerIds.forEach((graphicsLayerId) => {
			  const gLayer = map.getLayer(graphicsLayerId);

			  if (layerid) {					
						//console.log("Match Found, Clearing Specified " + gLayer.id);
						if (gLayer.id == layerid) {
						gLayer.clear();
						}
				} else { 
					//console.log("Clearing in aggregate " + gLayer.id);
					if (gLayer.id == layerid && (cgThis.execptions && !cgThis.exceptions.find((layerid) => { return layerid == gLayer.id }))) {
						gLayer.clear();
					} 
					//map.graphics.clear(); 
					fpLayer.graphics.map((graphic) => { buildingfootprintLayer.add(graphic) } )
				}
			});
		}*/

		vm.setClearGraphicsFunction(clearGraphics)

		// This once useful function appears to have no use now.
		function updateLayerVisibility(floor) {
			//console.log("Update Layer Visibility")
		}

		function addBuildingFootprints() {	
			//console.log("Add Building Footprints")
			var features = []
			//console.log("footprint URL", vm.buildingFootprintURL)
			var queryTask = new QueryTask(vm.buildingFootprintURL)

			var query = new Query();
			query.returnGeometry = true;
			query.outFields = ["*"];
			query.where = "1=1";

			queryTask.on("complete", function(event) {
				features = event.featureSet.features;
				
				if (features.length > 0) {	
				features.forEach(function(feature) {
					feature.setSymbol(outlineSymbol); 
					buildingfootprintLayer.add(feature);
					
					/*const mGraphic = new Graphic(feature.toJson())
					mGraphic.setSymbol(maskSymbol); 
					whiteoutLayer.add(mGraphic);*/
					
				});

				labelBuildings()

				} else { }
			})

			queryTask.execute(query);
		}

		function addRoomInteractivity(bldgAlpha) {	
			const uniqueKey = Math.floor((Math.random() * 1000) + 1);
			//console.log("addRoomInteractivity: id"+uniqueKey)
			
			var features = []
				//if (state.selectedBuilding) { 
					
					const serviceURL = vm.viewRestricted ? vm.secureFloorURL[store.state.ui.currentFloor] + '?token='+esriToken : vm.floorURL[store.state.ui.currentFloor]

					var queryTask = new QueryTask(serviceURL)

					var query = new Query();
					query.returnGeometry = true;
					query.outFields = ["*"];
					let bldg = bldgAlpha ? bldgAlpha : state.selectedBuilding ? state.selectedBuilding.bldgAlpha : null
					query.where = "ROOMEXT.BldgAlpha = '" + bldg + "'";

					queryTask.on("complete", function(event) {
						features = event.featureSet.features;
						//console.log("FeatureCount: ", features.length)
						if (features.length > 0) {	
						let added = false
						let drawingName = null
						features.forEach(function(feature) {
							feature.setSymbol(transparentSymbol); 
							//console.log("Add Room Interactive Graphic: id" + uniqueKey)

							// Prevents duplicate graphics from building up
							if (roominteractivityLayer.graphics.findIndex((graphic) => 
								graphic.attributes['ROOMEXT.roomKey'] == feature.attributes['ROOMEXT.roomKey']) == -1) {
								roominteractivityLayer.add(feature);
								added = true
								drawingName = feature.attributes['ROOMEXT.dwgname']
							} else {
								//console.log("Duplicate Graphic not added")
							}


							
						});

						// This works very poorly	
						//vm.addNullFeatures(drawingName)

						//if (added) { console.log(roominteractivityLayer.graphics.length + " Interactive Graphics") }
						if (vm.clVisible) { 
							applyLabels() 
						}

						} else { }
					})

					queryTask.execute(query);
				
				//} else { //console.log("Asked for Graphics, but no Building Selected")
				//}			
		}

    	var toggle = "" // Used to alternate , and \n seperator for large text arrays.  Two on a line this way.
    	var showmore = false

    	// How do labels even work?
    	// Labels do not work higher than zoom 22
    	// It requires a selected building
    	// PI, Occupant requires API:BuildingRoomsFull for additional data, pulls rooms for currentFloor.
    	// this function is vuex accessible through mutation "applyLabels"
    	// label(data) ensures we have both the roominteractivitylayer and the matching API data loaded
    	// labelCycle(data) loops through the RI Layer, finds matching data in API data, creates and applys label.
    	// There is a getter getLabelState in ui.js that is used to watch changes to all of the switches at once.  Any new switches/attributes, add to this.


    	const applyLabels = () => {    		
    		if (!vm.clVisible || map.getLevel() < 22) {
    			clearGraphics(CUSTOMLABELLAYER)
    			clearGraphics(COLORLAYER)
    			clearGraphics(WHITEOUTLAYER)
    			return
    		}

    		if (!vm.selectedBuilding ) { return }

    		if (vm.clName || vm.clPI || vm.clOccupant || vm.clHybrid) {
    			//console.log(vm.clPI, vm.clOccupant, vm.clHybrid)
    			//console.log("One of them true")
    			if (vm.buildingRoomsFull.length > 0) {
    				label(vm.buildingRoomsFull)
    			} else {
    				vm.setLoading(true)
		    		store.dispatch('fetchBuildingRoomsFull', {bldgAlpha: vm.selectedBuilding.bldgAlpha, floor: vm.currentFloor}).then((data) => {
			    		label(data)
			    		vm.setLoading(false)
		    	 	})
		    	}
	    	} else {
		    		label(vm.buildingRooms)	    	 	
	    	}
    	}

    	vm.setApplyLabelsFunction(applyLabels)

    	function label(data) {
    		console.log("Apply Labels")	
    		clearGraphics(CUSTOMLABELLAYER)   
    		clearGraphics(WHITEOUTLAYER)  
    		if(!roominteractivityLayer.graphics[0]) {console.log("Not Ready for Labels"); return;}		 			

    		// This is all a check to make sure we have the current floor in memory before calling labelCycle
    		// Test to see if the first graphic in RI Graphics can be found in BuildingRoomsFull
			let room = data.find((room) => { return room.roomKey == roominteractivityLayer.graphics[0].attributes['ROOMEXT.roomKey'] })

			if (!room) { // User switched floors, room not found.
				console.log("FullRooms needs refresh"); 
				vm.setLoading(true)
				store.dispatch('fetchBuildingRoomsFull', {bldgAlpha: vm.selectedBuilding.bldgAlpha, floor: vm.currentFloor}).then((data) => {
						vm.setLoading(false)
					 	labelCycle(data)		// This function loop through rooms and create label graphics
				})
			} else { 
				labelCycle(data) 
			}

			function labelCycle(data) {

	    		roominteractivityLayer.graphics.forEach((graphic) => {	 
	    			// Dont label graphics that aren't in currently selected building   			
	    			if (graphic.attributes['ROOMEXT.BldgAlpha'] != vm.selectedBuilding.bldgAlpha) {
	    				return
	    			}
	    			const gExt = graphic.geometry.getExtent()
	    			const gCenter = gExt.getCenter()

	    			room = data.find((room) => { return room.number == graphic.attributes['ROOMEXT.RM_ID'] })

	    			if (room.deptName == "Unassignable Space") { return } // Don't label Unassignable Space

	    			fitLabel(graphic)

	    			const customLabel = new TextSymbol().setColor(
										    new Color(vm.darkTheme ? [128,128,255] : [160,0,0])).setAlign(Font.ALIGN_START).setFont(
										    new Font(`${vm.clFontSize}pt`).setWeight(Font.WEIGHT_BOLD).setFamily('Roboto,sans-serif')) ; 

					// Halo for label text
					if (vm.clHalo) 		{ customLabel.setHaloColor(new Color([240, 240, 240])); 
										  customLabel.setHaloSize(1); }

	    			toggle = false		    			
	    			let labelText = ""
	    			let limiter = false
	    			
	    			if (vm.clRoomNumber)			{ labelText += (labelText.length>0 ? "\n" : "") + room.number}
	    			if (vm.clArea) 					{ labelText += (labelText.length>0 ? "\n" : "") + room.area + " sf" }	 
	    			if (vm.clName && room.name)   	{ labelText += (labelText.length>0 ? "\n" : "") + room.name }			
	    			if (vm.clOccupant) 				{ labelText += (labelText.length>0 ? "\n" : "") + getOccupantText(room);
	    											  limiter = true }			    			
	    			if (vm.clPI) 					{ labelText += (labelText.length>0 ? "\n" : "") + getPIText(room);
	    										 	  limiter = true }

	    			// Special request from UAHS
	    			if (vm.clHybrid) {
	    				limiter = true
	    				if (room.classification == 'Research') {
		    					// 255 is Lab Services
		    					if (room.categoryName.includes('Service'))
		    												{ labelText += (labelText.length>0 ? "\n" : "") + getRoomUseText(room) }
		    					else 						{ labelText += (labelText.length>0 ? "\n" : "") + getPIText(room) } 
		    			} else {
	    						if (room.categoryName=="Office")	
	    													{ labelText += (labelText.length>0 ? "\n" : "") + getOccupantText(room) }
		    					else 						{ labelText += (labelText.length>0 ? "\n" : "") + getRoomUseText(room) } 
		    			}
	    			}
	    			

	    			// set the text, create and add the graphic
	    			customLabel.setText(labelText)
	    			const labelGraphic = new Graphic(gCenter, customLabel);  
	    			if(vm.clLimitY > 0 || !limiter) customlabelLayer.add(labelGraphic) 
	    	 	})
    		}
    	}

    	function labelBuildings(zoomlevel) {
    		let bldgLabelSize = "16"
    		clearGraphics('buildinglabellayer')
    		if 		(zoomlevel == 20) { bldgLabelSize = 20; }
    		if (zoomlevel > 20) { bldgLabelSize = 24; }
     		if (zoomlevel > 24) { bldgLabelSize = 40; }

    		buildingfootprintLayer.graphics.forEach((graphic) => {

/*    			const whiteout = new Graphic(graphic.toJson())  		
	    		whiteout.setSymbol(vm.darkTheme ? blackFillSymbol : whiteFillSymbol)
	    		buildingfootprintLayer.add(whiteout)*/	

    			let buildingLabel = new TextSymbol().setColor(
										    new Color(vm.darkTheme ? [128,128,255] : [128,0,0,.5])).setAlign(Font.ALIGN_START).setFont(
										    new Font(`${bldgLabelSize}pt`).setWeight(Font.WEIGHT_BOLD).setFamily('Roboto,sans-serif')) ;  

				/*let buildingLabel2 = new TextSymbol().setColor(
										    new Color(vm.darkTheme ? [128,128,255] : [128,0,0,.5])).setAlign(Font.ALIGN_START).setFont(
										    new Font(`${bldgLabelSize}pt`).setWeight(Font.WEIGHT_BOLD).setFamily('Roboto,sans-serif')) ; */						    
				
				// Lookup shortName in building JSON
					/*let bldgAlpha = graphic.attributes['Buildings.SpaceNumLetter']
					let building = vm.buildings.find((building) => { return building.bldgAlpha == bldgAlpha })
					let shortName = building && building.shortName
					buildingLabel.setText(shortName)*/

				// Use the shorter of cartoName or buildingName
				let cartoName = graphic.attributes['Buildings.CartoName']
				let name = graphic.attributes['Buildings.Name']
				let labelText = cartoName	

				// Exceptions.  Do not label.
				let exceptionList = ['167A', '479', '476', '572', '475', '472', '155C', '155M', '155N', '155H', '409', '408', '408A']
				if (exceptionList.indexOf(graphic.attributes['Buildings.SpaceNumLetter']) > -1) { labelText = "" }				
				
				//name && cartoName && console.log(name, name.length, " : ", cartoName, cartoName.length)
				if (name && cartoName && name.length < cartoName.length) {
					labelText = name
					//console.log(name, " was shorter than", cartoName)
				}

				// Split text into two lines.  Works but needs zoom dependancy on offset to work.
					/*if (labelText) {
						let breakIndex = labelText && labelText.indexOf(" ", 10)
						let line1 = labelText.substr(0, breakIndex)
						let line2 = breakIndex && labelText.substr(breakIndex + 1)
						console.log(breakIndex, labelText, line1, line2)

						buildingLabel.setText(line1)
						buildingLabel2.setText(line2)
						buildingLabel2.setOffset(0,40)

						const gExt = graphic.geometry.getExtent()
				    	const gCenter = gExt.getCenter()
				    	const labelGraphic = new Graphic(gCenter, buildingLabel); 
						const labelGraphic2 = new Graphic(gCenter, buildingLabel2);

						buildinglabelLayer.add(labelGraphic)
						buildinglabelLayer.add(labelGraphic2)
				    }*/	

					// Original
						buildingLabel.setText(labelText)
						const gExt = graphic.geometry.getExtent()
				    	const gCenter = gExt.getCenter()
				    	const labelGraphic = new Graphic(gCenter, buildingLabel); 
				    	buildinglabelLayer.add(labelGraphic)

					// Offset testing
						/*let buildingLabel2 = buildingLabel
						label2.setOffset(0,20)
						const labelGraphic2 = new Graphic(gCenter, label2);
						buildinglabelLayer.add(labelGraphic2)*/
				

    		})
    	}

		function noDupPush(array, element) {
			//console.log(array, element)
			let found = array.indexOf(element)
			//console.log(found)
			if (found == -1) { array.push(element) }
		}

		function getOccupantText(room)	{
			//console.log("Getting Occupant Text")
			// Needs deduplication?
			let occupants = []
				room.PCT.map((pct) => {
					pct.occupant.map((occupant) => {
						if (vm.clNameBreak) {
								noDupPush(occupants, occupant[vm.clNaming].substr(0,vm.clLimitX*2)) // double limit since it will be broken into two lines	
						} else {  noDupPush(occupants, occupant[vm.clNaming].substr(0,vm.clLimitX))}					
					}) 						
				})
			
			let text = "" 	

			const oLimit = vm.clArea ? vm.clLimitY : vm.clLimitY + 1  // If no Area Label, we can use one more line.
			
			// if vm.clNameBreak, break name into two lines
			if (vm.clNameBreak) {
				occupants.forEach((name, index) => {
					if (index*2 >= oLimit) {  showmore = true; return   } // index*2 = number of lines since each line is 2 now
					// replace space with linebreak
					text += name.split(" ").join("\n") + joiner() 
				})
			} else {
				occupants.forEach((name, index) => {
					if (index >= oLimit) {  showmore = true; return  } 
					text += name + joiner() 
				})
			}

			//if (text != "") {
			//	text = "\n" + text
			//}

			if (showmore) {
				text += "more..."
				showmore = false
			}					
			return (text.length > 0 ) ? text.replace(/,\s*$/, "") : "" // removes final comma
		}

		function getRoomUseText(room)	{
			//console.log("Getting Room Use Text")
				

			//text += room.typeName.slice(-vm.clLimitX) + joiner() 
			let text = room.useName.substr(0,vm.clLimitX) + joiner()
			

			/*if (text != "") {
				text = "\n" + text
			}*/

			return (text.length > 0 ) ? text.replace(/,\s*$/, "") : "" // removes final comma
		}

    	function getPIText(room) {
    		let PIs = []
				room.PCT.map((pct) => {
					pct.PI.map((PI) => {
						if (vm.clNameBreak) {
							noDupPush(PIs, PI[vm.clNaming].substr(0,vm.clLimitX*2)) // double limit since it will be broken into two lines
						} else { noDupPush(PIs, PI[vm.clNaming].substr(0,vm.clLimitX)) }
					}) 						
				})
			
			let text = "" 	

			const oLimit = vm.clArea ? vm.clLimitY : vm.clLimitY + 1  // If no Area Label, we can use one more line.			

			// if vm.clNameBreak, break name into two lines
			if (vm.clNameBreak) {
				PIs.forEach((name, index) => {
					if (index*2 >= oLimit) {  showmore = true; return  } // index*2 = number of lines since each line is 2 now
					// replace space with linebreak
					text += name.split(" ").join("\n") + joiner() 
				})
			} else {
				PIs.forEach((name, index) => {
					if (index >= oLimit) {  showmore = true; return  }
					text += name + joiner() 
				})
			}

			//if (text != "") {
			//	text = "\n" + text
			//}

			if (showmore) {
				text += "\nmore..."
				showmore = false
			}

			return (text.length > 0 ) ? text.replace(/,\s*$/, "") : "" // removes final comma
		}
		
		function joiner() {
			if (vm.clWrap == 'wrap1') {
				return ", \n"
			} else {
				toggle = !toggle
				return toggle ? ", " : ",\n"
			}
		}

		function adjustFontLabelFontSize(zoom) {
			let fontSize = null;
			switch(zoom) {
			    case 21: 	fontSize = 6;	break;
			    case 22: 	fontSize = 7;	break;
			    case 23: 	fontSize = 8;	break;
			    case 24: 	fontSize = 8;	break;
			    case 25: 	fontSize = 8;	break;
			    case 26: 	fontSize = 9;	break;
			    case 27: 	fontSize = 9;	break;
			    case 28: 	fontSize = 9;	break;
			    case 29: 	fontSize = 9;	break;
			    case 30: 	fontSize = 9;	break;
			    case 31: 	fontSize = 9;	break;
			    case 32: 	fontSize = 9;	break;
			    case 33: 	fontSize = 9;	break;
			    default:
			}

			if (fontSize != vm.clFontSize) { 
				vm.setclFontSize(fontSize) 
			} else {
				applyLabels()
			}
		}

		function fitLabel(graphic) {
			const zoom = map.getLevel()
			//console.log("fitLabel zoom:", zoom)
			const width = graphic.geometry.getExtent().getWidth()
			const height = graphic.geometry.getExtent().getHeight()
			let limitY = null
			let limitX = null

			switch(zoom) {
				case 22:
					
					switch(true) {
			    		case height > 11.5: limitY = 4; break;
			    		case height > 4.5: 	limitY = 1; break;
						case height > 0:	limitY = 0; break;						
					    default:					    
					}
					switch(true) {
			    		case width < 3: 	limitY = 0; break;
					    default:					    
					}
			    	break;
				case 23:
					switch(true) {
			    		case height > 11.5: limitY = 5; break;
			    		case height > 8.0:  limitY = 3; break; 
			    		case height > 4.5: 	limitY = 1; break;
						case height > 0:	limitY = 0; break;						
					    default:					    
					}
					switch(true) {
			    		case width < 3: 	limitY = 0; break;
					    default:					    
					}
			    	break;
				case 24:
				switch(true) {
						case height > 20:  	limitY = 25; break;
			    		case height > 11.5: limitY = 8; break;
			    		case height > 8.0:  limitY = 4; break; 
			    		case height > 5: 	limitY = 1; break;
						case height > 0:	limitY = 1; break;						
					    default:
					    
					}
					switch(true) {
			    		case width < 3: 	limitY = 0; break;
					    default:					    
					}
			    	break;
			    case 25: 	
			    	switch(true) {
			    		case height > 20:  	limitY = 25; break;
			    		case height > 11.5: limitY = 9; break;
			    		case height > 8.0:  limitY = 6; break; 
			    		case height > 5: 	limitY = 1; break;
						case height > 0:	limitY = 1; break;						
					    default:
					    
					}
			    	break;
			    case 26: 	
			    	switch(true) {
			    		case height > 20:  	limitY = 25; break;
			    		case height > 11.5: limitY = 9; break;
			    		case height > 8.0:  limitY = 5; break; 
			    		case height > 5: 	limitY = 1; break;
						case height > 0:	limitY = 1; break;						
					    default:
					}
			    	break;
			    case 27: 	
			    	switch(true) {
			    		case height > 20:  	limitY = 25; break;
			    		case height > 11.5: limitY = 9; break;
			    		case height > 8.0:  limitY = 7; break; 
			    		case height > 5: 	limitY = 3; break;
			    		case height > 4:	limitY = 3; break;
			    		case height > 3:	limitY = 2; break;
						case height > 0:	limitY = 1; break;						
					    default:
					}
			    	break;			    
			    case 28: 	
			    	switch(true) {
			    		case height > 20:  	limitY = 25; break;
			    		case height > 11.5: limitY = 10; break;
			    		case height > 8.0:  limitY = 9; break; 
			    		case height > 5: 	limitY = 4; break;
						case height > 4:	limitY = 4; break;	
						case height > 3:  	limitY = 2; break;	
						case height > 0:    limitY = 1; break; 				
					    default:
					}
			    	break;
			    case 29: 	
			    	switch(true) {
			    		case height > 20:  	limitY = 25; break;
			    		case height > 11.5: limitY = 10; break;
			    		case height > 8.0:  limitY = 10; break; 
			    		case height > 5: 	limitY = 6; break;
						case height > 4:	limitY = 6; break;	
						case height > 3:  	limitY = 3; break;	
						case height > 0:    limitY = 1; break; 				
					    default:
					}
			    	break;
			    case 30: 	
			    	switch(true) {
			    		case height > 20:  	limitY = 25; break;
			    		case height > 11.5: limitY = 10; break;
			    		case height > 8.0:  limitY = 10; break; 
			    		case height > 5: 	limitY = 7; break;
						case height > 4:	limitY = 7; break;	
						case height > 3:  	limitY = 4; break;	
						case height > 2:  	limitY = 2; break;	
						case height > 0:    limitY = 1; break; 				
					    default:
					}
			    	break;
			    case 31: 	
			    	switch(true) {
			    		case height > 20:  	limitY = 25; break;
			    		case height > 11.5: limitY = 10; break;
			    		case height > 8.0:  limitY = 10; break; 
			    		case height > 5: 	limitY = 7; break;
						case height > 4:	limitY = 9; break;	
						case height > 3:  	limitY = 6; break;	
						case height > 2:  	limitY = 2; break;	
						case height > 0:    limitY = 1; break; 				
					    default:
					}
			    	break;
			    case 32: 	
			    	switch(true) {
			    		case height > 20:  	limitY = 25; break;
			    		case height > 11.5: limitY = 10; break;
			    		case height > 8.0:  limitY = 10; break; 
			    		case height > 5: 	limitY = 10; break;
						case height > 4:	limitY = 10; break;	
						case height > 3: 	limitY = 8; break;
						case height > 2:  	limitY = 3; break;	
						case height > 0:    limitY = 1; break; 				
					    default:
					}
			    	break;
			    case 33: 	
			    	switch(true) {
			    		case height > 20:  	limitY = 25; break;
			    		case height > 11.5: limitY = 20; break;
			    		case height > 8.0:  limitY = 20; break; 
			    		case height > 5: 	limitY = 16; break;
						case height > 4:	limitY = 13; break;	
						case height > 3: 	limitY = 10; break;
						case height > 2:  	limitY = 5; break;	
						case height > 0:    limitY = 2; break; 				
					    default:
					}
			    	break;
			    default:
			}

			if (limitY!=null) { vm.setclLimitY(limitY) }
			if (limitX!=null) { vm.setclLimitX(limitX) }

		}



		// This stuff makes it so you can do a multiline label with "\n"
		if( typeof esri.layers.LabelLayer.prototype._addLabel == 'function' )
		{
			esri.layers.LabelLayer.prototype._addLabel2 = esri.layers.LabelLayer.prototype._addLabel;
			esri.layers.LabelLayer.prototype._addLabel = function(a,b,c,e,g,k,m)
			{
				// replace \n by <br>
				a = a.replace(/\n/g, "<br />");
				this._addLabel2(a,b,c,e,g,k,m);
			}
		}
			

		// This stuff makes it so you can do a multiline label with "\n"
		if( typeof dojox.gfx.svg.Text.prototype.setShape == 'function' )
		{
			dojox.gfx.svg.Text.prototype.setShape = function(p)
			{
				this.shape = dojox.gfx.makeParameters(this.shape, p);
				this.bbox = null;
				var r = this.rawNode, s = this.shape;
				r.setAttribute("x", s.x);
				r.setAttribute("y", s.y);
				r.setAttribute("text-anchor", s.align);
				r.setAttribute("text-decoration", s.decoration);
				r.setAttribute("rotate", s.rotated ? 90 : 0);
				r.setAttribute("kerning", s.kerning ? "auto" : 0);
				r.setAttribute("text-rendering", "optimizeLegibility");
				
				while(r.firstChild)
					r.removeChild(r.firstChild);

				if(s.text)
				{ 
					var texts = s.text.replace(/<br\s*\/?>/ig, "\n").split("\n");
					var lineHeight = 1.1 * parseInt(document.defaultView.getComputedStyle(r, "").getPropertyValue("font-size"), 10); 
					if( isNaN(lineHeight) || !isFinite(lineHeight) )
						lineHeight = 15;
						
					for(var i = 0, n = texts.length; i < n; i++)
					{ 
						var tspan = (document.createElementNS ? document.createElementNS(dojox.gfx.svg.xmlns.svg, "tspan") : document.createElement("tspan"));
						tspan.setAttribute("dy", i ? lineHeight : -(texts.length-1)*lineHeight/2); 
						tspan.setAttribute("x", s.x);
						tspan.appendChild((dojox.gfx.useSvgWeb ? document.createTextNode(texts[i], true) : document.createTextNode(texts[i]))); 
						r.appendChild(tspan);
					}
				}

				return this;
			}
		}

		
			

		
////////////////////////////////////////////////////////////////////
//
// End of Mounted Hook
//
////////////////////////////////////////////////////////////////////
	})
	.catch(err => {
		// handle any script or module loading errors
		console.error(err);
	});


	}, // close tag of 'mounted'


	components: { Legend, GlobalElevatorControl, DarkenMapOverlay, SwitchCampus, MOTD, GISServiceDownDialog, BetaAlert },

	data () {
		return {
			serviceDownDialog: false,
		}
	},

	created : function () {
		// This will default the Building Card closed for phone use
		if (this.$vuetify.breakpoint.smAndDown) { this.setBuildingCardOpen(false) }
	},



	computed : {
		...mapGetters([
				'getRoom', 'getMapSelectors', 'getBuilding', 
				'floorURL', 'secureFloorURL', 'initialFeaturesURL','buildingFootprintURL', 'lightBasemapURL', 'subBasemapURL', 'CACBasemapURL', 'B2BaseMapURL', 'TPBaseMapURL', 'phxBasemapURL', 'UASouthBaseMapURL', 'darkInterior', 'lightInteriorOpen', 'maskingLayerURL', 'lightInteriorSecured', 'subBasemapURL', 'darkBasemap',  'allowManagerUI', 'allowOccupantEditorUI'		]),

		...mapState({
				measureOpen: state => state.ui.measureOpen,
				selectedRoom: state => state.space.selectedRoom,
				selectedBuilding: state => state.space.selectedBuilding,
				colorizeArray: state => state.space.colorizeArray,
				customLabels: state => state.ui.customLabels, 
				buildings: state => state.space.buildings,
				buildingRooms: state => state.space.buildingRooms,
				buildingRoomsFull: state => state.space.buildingRoomsFull,
				currentFloor: state => state.ui.currentFloor,
				showBuildingLabels: state => state.ui.showBuildingLabels,
				darkTheme: state => state.ui.darkTheme,
				showLineDetail: state => state.ui.showLineDetail,
				selectionCentering: state => state.ui.selectionCentering,
				isSuperUser: state => state.user.isSuperUser,
				clVisible: state => state.ui.clVisible,
				clFontSize: state => state.ui.clFontSize,
				clRoomNumber: state => state.ui.clRoomNumber,
				clArea: state => state.ui.clArea,
				clName: state => state.ui.clName,
				clPI: state => state.ui.clPI,
				clOccupant: state => state.ui.clOccupant,
				clHybrid: state => state.ui.clHybrid,
				clNaming: state => state.ui.clNaming,
				clWrap: state => state.ui.clWrap,
				clHalo: state => state.ui.clHalo,
				clLimitX: state => state.ui.clLimitX,
				clLimitY: state => state.ui.clLimitY,
				clNameBreak: state => state.ui.clNameBreak,
				deptColors: state => state.ui.deptColors,
				categoryColors: state => state.ui.categoryColors,
				viewRestricted: state => state.user.viewRestricted,
				legendOpen: state => state.ui.legendOpen,
				mapReady: state => state.mapFunctions.mapReady,
				userProfile: state => state.user.userProfile,
				roomAssociationSidebarOpen: state => state.ui.roomAssociationSidebarOpen,
				autoMode: state => state.association.autoMode,
				databaseRoom: state => state.association.databaseRoom,
				associationRoom: state => state.association.room,
				showCadText: state => state.ui.showCadText,
				showCadPlan: state => state.ui.showCadPlan,
				siteExtents: state => state.mapFunctions.siteExtents,
				multiSelectRoomArray: state => state.ui.multiSelectRoomArray,
				interiorMappingDMSL: state => state.mapFunctions.interiorMappingDMSL,
				BulkRoomEditSideBarOpen: state => state.ui.BulkRoomEditSideBarOpen,
				roomCollectionAutoAdd: state => state.ui.roomCollectionAutoAdd,
				floorToInteriorSublayerId: state => state.restServices.floorToInteriorSublayerId,
			}),


		stateMap () { return this.$store.state.mapFunctions.stateMap },
		clearGraphics (value) { return this.$store.state.mapFunctions.clearGraphics}
	},
	// ...
	mutations: {
		
	},

	methods: {
	  ...mapMutations([	'updateContentSidebar', 
	  					'updateSelectionCentering',
	  					'setHoverRoomNumber',
	  					'setSelectedRoom',
	  					'setCurrentFloor',
	  					'setBuildingCardOpen',
	  					'setMap',
	  					'setHighlightBuildingFunction',
	  					'setHighlightRoomByKeyFunction',
	  					'setHighlightRoomsByKeyFunction',
	  					'setRemoveGraphicFunction',
						'setClearGraphicsFunction',
						'setApplyLabelsFunction',
						'showMeasure',
						'setLoading',
						'setclFontSize',
						'setclVisible',
						'setclLimitX',
						'setclLimitY',
						'setViewRestricted',
						'setLegendColors',
						'updateBulkRoomEditSideBar',
						'addToMultiSelectRoomArray',
						'setMultiSelectRoomArray',
						'setMapReady',
						'setDatabaseRoom',
						'setInteriorMappingDMSL',
						'setSnackText', 'SET_GEOMETRY_SERVICE',
						'setDarkenOverlay',
						'updateCollectionSidebar',
						'setHighlightRoomFunction',
						'updateRoomAssociationSidebar',
	  				]),
	  ...mapActions(['selectBuilding', 'fetchBuildings', 'fetchBuildingRoomsFull', 'fetchBuildingFiles', 'addLayer', 'hoverHighlightNullFeature',
	  				 'addGraphicsLayer', 'fetchFullRoom', 'addNullFeatures', 'setAssociationRoom', 'highlightNullFeature',
	  				 'newRoomAutoSave', 'fetchFullRoomByJoinKey', 'symbolizeNullFeatureLayer', 'addText', 'addExtents', 'buildColorizedLegendArray', 'loadRIForExtent', 'roomClickEvent', 'buildingClickEvent', 'roomHoverEvent', 'buildingHoverEvent', 'setupSymbols', 'addFloorPlanDetail', 'useSelectRectangle'
	  				 ]),


	  clickMeasureTool: function () {
	  	if (this.measureOpen) { this.clearGraphics()}
	  	this.showMeasure(this.measureOpen = !this.measureOpen)
	  },
	  

	// Not currently used, but demonstrates how we're not trapped in the main function.
	externalClearGraphics : function (layerid, vm) {
			console.log(vm.$store.state.mapFunctions.stateMap.id)
			console.log("externalClearGraphics mapid: " + vm.$store.state.mapFunctions.stateMap.id)
			loadModules([
			"esri/layers/GraphicsLayer"
			])
			.then(
			function ([GraphicsLayer]) {
				console.log(layerid)
				//console.log(vm.$store.state.space.stateMap)
				//console.log(vm.$store.state.space.stateMap)
				console.log("Asked to Clear " + layerid);
				vm.$store.state.mapFunctions.stateMap.graphicsLayerIds.forEach((graphicsLayerId) => {
				  	const gLayer = vm.$store.state.mapFunctions.stateMap.getLayer(graphicsLayerId);

				  	if (layerid) {
						if (gLayer.id == layerid) {
							//console.log("Match Found, Clearing Specified " + gLayer.id);
							gLayer.clear();
						}
					} else { 
						//console.log("Clearing in aggregate " + gLayer.id);
						gLayer.clear(); 
						vm.$store.state.mapFunctions.stateMap.graphics.clear();  
					}
				});

			}) 
		},

	},

/*	watch: {
	  '$route'(route) {
		//if (route.path === ('/test')) {
		  //console.log("Route Test")
		  //this.selectBuilding(route.split("/")[1])
		  //this.updateContentSidebar(true)
		//}
	  }
	},*/
}	  
</script>

<style>

html, body, #map, .esrimapcomponent{
	padding: 0;
	margin: 0;
	height: 100%;
	overflow-y: hidden !important;

}

#map {
	position: relative;
}

body {
	min-height: 100%;
	background-color: #fff;
	font-family: Arial, sans-serif;
	font-size: 14px;
	line-height: 20px;
	color: #333;
}
 #titlePane{
        width:280px;
		background: white;
      }
#map_zoom_slider { top: 90px; display:none;}

#layerList {
    position: absolute !important;
    top:  100px; left: 10px;
    z-index: 100000 !important;
}

/*
.dijitPopup.dijitMenuPopup{
	left: 945px !important;
    top: 772px !important;
    width: 8%;
    right: -13px !important;
    background: #fff;
    position: absolute;
}
*/
#chart {
  width: 200px;
  height: 200px;
  background: blue;
}

.toolActive {
	border-width: 5px;
	border-style: solid;
	border-color: #1976d2;
}

.esriMeasurementResultValue {
	display: block !important; 
	text-align: center !important; 
}

.scaleLabelDiv {
	right: 50px;
}

.esriScalebar {
	z-index: 0 !important;
}

.esriScalebarRuler {
	right: 50px;
}

.thickerOutline {
    border-width: 1px;
    border-radius: 5px;
    border-style: solid;
    border-color:  #57585A;
}

</style>



// WEBPACK FOOTER //
// src/components/esri-map.vue